import type { Heidi2OnboardingFlow } from '../../onboarding/Heidi2OnboardingFlow';

type Heidi2OnboardingFlowModule = typeof import('../../onboarding/Heidi2OnboardingFlow');
type Heidi2OnboardingFlowComponent = typeof Heidi2OnboardingFlow;

let loadedFlow: Heidi2OnboardingFlowComponent | null = null;
let loading: Promise<Heidi2OnboardingFlowModule> | null = null;

export const preloadHeidi2OnboardingFlow = (): Promise<Heidi2OnboardingFlowModule> => {
  loading ??= import('../../onboarding/Heidi2OnboardingFlow').then(
    (module) => {
      loadedFlow = module.Heidi2OnboardingFlow;
      return module;
    },
    (error: unknown) => {
      loading = null;
      throw error;
    }
  );
  return loading;
};

export const getLoadedHeidi2OnboardingFlow = (): Heidi2OnboardingFlowComponent | null =>
  loadedFlow;

export const resetHeidi2OnboardingFlowLoaderForTests = (): void => {
  loadedFlow = null;
  loading = null;
};
